/**
 * @desc Yung-提交表单
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.ApprovalRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/approval/formSubmit`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
